import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import {
    AttendanceStateEnum,
    type AttendanceDataRawData,
} from '@/Shared/AutoGenerated/Main'
import type HasSchedulingStateInterface from '@/App/Booking/Shared/Entity/HasSchedulingStateInterface'
import type {
    SchedulingStateBadgeColor,
    SchedulingStateBadgeLabel,
} from '@/App/Booking/Shared/Entity/HasSchedulingStateInterface'
import Attendance from '@/App/Booking/Attendance/Entity/Attendance'

export default class AttendanceData implements HasSchedulingStateInterface {
    constructor(public readonly attendance: Attendance) {
        ensureNoUndefinedProperties(this)
    }

    isCanceled(): boolean {
        return this.attendance.state === AttendanceStateEnum.Canceled
    }

    // ------------------------
    // HasSchedulingStateInterface implementation
    // ------------------------

    getSchedulingStateBadgeLabel(): SchedulingStateBadgeLabel {
        return this.attendance.getSchedulingStateDataEntry().label
    }

    getSchedulingStateBadgeColor(): SchedulingStateBadgeColor {
        if (this.attendance.state === AttendanceStateEnum.Scheduled) {
            return 'success'
        }

        if (this.attendance.state === AttendanceStateEnum.Canceled) {
            return 'secondary'
        }

        if (this.attendance.state === AttendanceStateEnum.Completed) {
            return 'info'
        }

        if (this.attendance.state === AttendanceStateEnum.NoShow) {
            return 'warning'
        }

        throw new Error(`Unknown meeting state ${this.attendance.state}`)
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: AttendanceDataRawData): AttendanceData {
        return new AttendanceData(
            Attendance.hydrateSingle(entityData.attendanceRawData),
        )
    }

    static hydrateMultiple(
        entitiesData: AttendanceDataRawData[],
    ): AttendanceData[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
